import { collection, getDocs, updateDoc, doc } from 'firebase/firestore';
import { db } from '../firebase';

export const migrateCompanyMembers = async () => {
  try {
    console.log('🔄 Starting CompanyMember migration...');
    
    // Get all company members
    const membersSnapshot = await getDocs(collection(db, 'companyMembers'));
    const members = membersSnapshot.docs;
    
    console.log(`📊 Found ${members.length} company members to migrate`);
    
    let updatedCount = 0;
    let skippedCount = 0;
    
    for (const memberDoc of members) {
      const memberData = memberDoc.data();
      
      // Check if joinedAt field is missing
      if (!memberData.joinedAt) {
        // Use invitedAt as joinedAt if available, otherwise use current timestamp
        const joinedAt = memberData.invitedAt || new Date().toISOString();
        
        // Update the document
        await updateDoc(doc(db, 'companyMembers', memberDoc.id), {
          joinedAt: joinedAt
        });
        
        console.log(`✅ Updated member ${memberDoc.id} with joinedAt: ${joinedAt}`);
        updatedCount++;
      } else {
        console.log(`⏭️ Skipped member ${memberDoc.id} - already has joinedAt`);
        skippedCount++;
      }
    }
    
    console.log(`🎉 Migration complete!`);
    console.log(`✅ Updated: ${updatedCount} members`);
    console.log(`⏭️ Skipped: ${skippedCount} members`);
    
    return {
      success: true,
      updated: updatedCount,
      skipped: skippedCount,
      total: members.length
    };
    
  } catch (error) {
    console.error('❌ Migration failed:', error);
    return {
      success: false,
      error: error
    };
  }
};
